import { CourseTileData } from '../../components/CourseTile/types';
import { SelectorOption } from '../../components/Forms/Selector/types';

export type CourseSearchResults = {
  courses: Readonly<CourseTileData[]>;
  total: number;
};

export type CourseListingPageState = {
  loaded: boolean;
  featuredCourses: Readonly<CourseTileData[]>;
  featuredInstitutions: Readonly<SelectorOption[]>;
  categories: Readonly<string[]>;
  searchResults: CourseSearchResults;
  requestId: number;
  processing: boolean;
  error?: string;
};

export const INITIAL_STATE: CourseListingPageState = {
  loaded: false,
  featuredCourses: [],
  featuredInstitutions: [],
  categories: [],
  searchResults: {
    courses: [],
    total: 0,
  },
  processing: false,
  requestId: 0,
};
